import {collection, dateField, EntityData, field, identifier, transientField} from "@fedeltapointofsale/data-client";

export class IntegratedInstaanceLocation extends EntityData<IntegratedInstaanceLocation> {
    @field locationId;
    @field webTerminalId: number;
    @field webTerminalName: string;
}

export class IntegratedInstanceSearchData extends EntityData<IntegratedInstanceSearchData> {
    @identifier instanceId: string;
    @field instanceName: string;
    @field integratorId: string;
    @field integratorName: string;
    @field instanceUrl: string;
    @collection(IntegratedInstaanceLocation) locations: IntegratedInstaanceLocation[];
    @dateField lastLogin: Date;

    get webTerminalNames(): string {
        return this.locations.map(location => location.webTerminalName).join(", ");
    }
}
